import React, { useState } from "react";
import "./Support.css";

const faqs = [
  {
    q: "Comment commander sur Dollar Store ?",
    a: "Vous pouvez passer votre commande directement sur notre site web dollarstoretogo.com. Choisissez vos produits, ajoutez-les au panier et suivez les étapes de validation.",
  },
  {
    q: "Vendez-vous uniquement des produits américains ?",
    a: "Oui, nous proposons principalement des produits importés des États-Unis, sélectionnés pour leur qualité et leur authenticité.",
  },
  {
    q: "Livrez-vous partout au Togo ?",
    a: "Oui, nous proposons la livraison selon votre localisation. Vous pouvez aussi récupérer votre commande dans l’un de nos points de vente.",
  },
  {
    q: "Quels sont vos moyens de paiement ?",
    a: "Nous acceptons différents moyens de paiement sécurisés. Les options disponibles vous seront proposées lors de la validation de votre commande.",
  },
  {
    q: "Combien de temps prend une commande ?",
    a: "Le délai dépend de la disponibilité du produit et du mode de livraison choisi. Notre équipe vous informe à chaque étape de votre commande.",
  },
  {
    q: "Puis-je modifier ou annuler ma commande ?",
    a: "Oui, tant que la commande n’a pas encore été traitée ou expédiée. Contactez rapidement notre service client pour toute modification.",
  },
  {
    q: "Comment contacter le service client ?",
    a: "Vous pouvez nous contacter par email, par téléphone ou directement dans l’un de nos points de vente pendant les heures d’ouverture.",
  },
  {
    q: "Où se trouvent vos points de vente ?",
    a: "Nos points de vente sont situés à Cassablanca, Baguida et Dékon. Nous vous accueillons tous les jours de 08h00 à 21h00.",
  },
];

export default function Support() {
  const [open, setOpen] = useState(null);

  return (
    <div className="support-container-sp">
      {/* En-tête */}
      <header className="support-header-sp">
        <h1 className="support-title-sp">Contactez notre service client</h1>
        <p className="support-subtitle-sp">
          Dites-nous en quoi nous pouvons vous aider.
        </p>
      </header>

      {/* Cartes de contact */}
      <div className="support-cards-sp">
        <div className="support-card-sp">
          <h3>Email</h3>
          <p>Contactez notre service client par email.</p>
          <a href="mailto:dollarstore@dollarstoretogo.com">
            dollarstore@dollarstoretogo.com
          </a>
        </div>

        <div className="support-card-sp">
          <h3>Téléphone</h3>
          <p>Un simple appel suffit.</p>
          <a href="tel:+22890045926">+228 90 04 59 26</a>
        </div>

        <div className="support-card-sp">
          <h3>Points de vente</h3>
          <p>Ouverts de 08h00 à 21h00</p>
          <a href="https://dollarstoretogo.com" target="_blank" rel="noreferrer">
            Cassablanca, Baguida et Dékon
          </a>
        </div>
      </div>

      {/* FAQ */}
      <section className="support-faq-sp">
        <h2 className="faq-title-sp">Questions fréquemment posées</h2>
        <div className="faq-list-sp">
          {faqs.map((item, i) => (
            <div
              key={i}
              className={`faq-item-sp ${open === i ? "open" : ""}`}
              onClick={() => setOpen(open === i ? null : i)}
            >
              <div className="faq-question-sp">
                <span>{item.q}</span>
                <span className="faq-icon-sp">{open === i ? "−" : "+"}</span>
              </div>
              {open === i && <p className="faq-answer-sp">{item.a}</p>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}